<i18n>
{
	"en": {
		"title" : "New EDIPART",
		"name" : "Edipart Name",
		"description" : "Edipart description",
		"edipartWarningMessage": "EDI Part requires a name",
		"notifyEdipartCreated": "EDI part successfully created"
	},
	"no":{
		"title" : "Ny EDIPART",
		"name" : "Edipart navn",
		"description" : "Edipart description",
		"edipartWarningMessage": "EDI Parten krever ett navn",
		"notifyEdipartCreated": "EDI part opprettet"
	}
}
</i18n>
<template>
	<t-dialog
		:title="$t('title')"
		:isShown="showNewEdipartDialog"
		:icon="'settings'"
		iconType="bp"
		:isConfirmDisabled="confirmDisabled"
		@close="close"
		@ok="create"
		@cancel="close"
	>
		<div class="new-edipart">
			<t-text-input
				v-model="edipart.name"
				:label="$t('name')"
				:warningMessage="edipartWarningMessage"
			/>
			<t-text-input
				v-model="edipart.description"
				:label="$t('description')"
			/>

		</div>

	</t-dialog>
</template>

<script>

import { mapActions } from '../store/edipart.store';
export default {
	props: { showNewEdipartDialog: Boolean },

	data() {
		return {
			edipart: { name: '', description: '' },
			edipartWarningMessage: '',
			confirmDisabled: true,
		};
	},
	watch:{
		'edipart.name': function(newVal) {
			if (newVal === '') {
				this.setErrorMessage();
			} else {
				this.clearErrorMessage();
			}
		}
	},
	methods: {
		...mapActions(['executeCreateEdipart']),
		async create() {
			if (this.edipart.name === '') {
				this.setErrorMessage();
				return;
			}
			this.clearErrorMessage();
			this.executeCreateEdipart(this.edipart);
			this.$notify({
				type: 'success',
				title: this.$t('notifyEdipartCreated')
			});
		},

		setErrorMessage() {
			this.confirmDisabled = true;
			this.edipartWarningMessage = this.$t('edipartWarningMessage');
		},

		clearErrorMessage() {
			this.confirmDisabled = false;
			this.edipartWarningMessage = '';
		},
		close() {
			this.$emit('close');
		}
	}

};
</script>

<style lang="scss" scoped>
.new-edipart{
	display:grid;
	grid-template-columns: 250px 450px;
	column-gap: 20px;
}
</style>